import AppDispatcher from '../dispatcher';
import Constant from '../constants.js/Constant';

var BASE_URL = 'https://dev.localclarity.com/translations';

var GetTranslationAction = function () {}

GetTranslationAction.prototype = {

    // GET /api/i18n/:lng/:page  — flat bundle for a page
    get: function (lng, page) {
        fetch(BASE_URL + '/api/admin/pages/' + page + '?size=100000', { cache: 'no-store' })
        .then(function (res) { return res.json(); })
        .then(function (bundle) {
            AppDispatcher.dispatch({ actionType: Constant.GET_TRANSLATION, data: bundle });
        })
        .catch(function (err) { console.error('[Translation] fetch failed', err); });
    },

    // GET /admin/languages
    getLanguages: function () {
        fetch(BASE_URL + '/admin/languages', { cache: 'no-store' })
        .then(function (res) { return res.json(); })
        .then(function (data) {
            AppDispatcher.dispatch({ actionType: Constant.GET_TRANSLATION, data: { languages: data } });
        })
        .catch(function (err) { console.error('[Translation] getLanguages failed', err); });
    },

    // POST /admin/languages
    addLanguage: function (code, name) {
        fetch(BASE_URL + '/admin/languages', {
            method: 'POST',
            cache: 'no-store',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ code: code, name: name })
        })
        .then(function (res) { return res.json(); })
        .then(function (data) {
            AppDispatcher.dispatch({ actionType: Constant.GET_TRANSLATION, data: data });
        })
        .catch(function (err) { console.error('[Translation] addLanguage failed', err); });
    },

    // GET /admin/pages
    getPages: function () {
        fetch(BASE_URL + '/admin/pages', { cache: 'no-store' })
        .then(function (res) { return res.json(); })
        .then(function (data) {
            AppDispatcher.dispatch({ actionType: Constant.GET_TRANSLATION, data: { pages: data } });
        })
        .catch(function (err) { console.error('[Translation] getPages failed', err); });
    },

    // GET /admin/pages/:page
    getPage: function (pageName) {
        fetch(BASE_URL + '/admin/pages/' + pageName, { cache: 'no-store' })
        .then(function (res) { return res.json(); })
        .then(function (data) {
            AppDispatcher.dispatch({ actionType: Constant.GET_TRANSLATION, data: data });
        })
        .catch(function (err) { console.error('[Translation] getPage failed', err); });
    },

    // POST /admin/pages
    addPage: function (pageName) {
        fetch(BASE_URL + '/admin/pages', {
            method: 'POST',
            cache: 'no-store',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ page_name: pageName })
        })
        .then(function (res) { return res.json(); })
        .then(function (data) {
            AppDispatcher.dispatch({ actionType: Constant.GET_TRANSLATION, data: data });
        })
        .catch(function (err) { console.error('[Translation] addPage failed', err); });
    },

    // POST /admin/pages/:page/keys
    addKey: function (pageName, keyName, translations) {
        fetch(BASE_URL + '/admin/pages/' + pageName + '/keys', {
            method: 'POST',
            cache: 'no-store',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ key_name: keyName, translations: translations })
        })
        .then(function (res) { return res.json(); })
        .then(function (data) {
            AppDispatcher.dispatch({ actionType: Constant.GET_TRANSLATION, data: data });
        })
        .catch(function (err) { console.error('[Translation] addKey failed', err); });
    },

    // PUT /admin/pages/:page/keys/:key
    updateKey: function (pageName, keyName, translations) {
        fetch(BASE_URL + '/admin/pages/' + pageName + '/keys/' + keyName, {
            method: 'PUT',
            cache: 'no-store',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ translations: translations })
        })
        .then(function (res) { return res.json(); })
        .then(function (data) {
            AppDispatcher.dispatch({ actionType: Constant.GET_TRANSLATION, data: data });
        })
        .catch(function (err) { console.error('[Translation] updateKey failed', err); });
    },

    // DELETE /admin/pages/:page/keys/:key
    deleteKey: function (pageName, keyName) {
        fetch(BASE_URL + '/admin/pages/' + pageName + '/keys/' + keyName, {
            method: 'DELETE',
            cache: 'no-store'
        })
        .then(function (res) { return res.json(); })
        .then(function (data) {
            AppDispatcher.dispatch({ actionType: Constant.GET_TRANSLATION, data: data });
        })
        .catch(function (err) { console.error('[Translation] deleteKey failed', err); });
    }

};

export default new GetTranslationAction();
